<template>
  <v-card rounded flat class="main">
    <v-row justify="center" class="purpleContainer">
      <v-img
        src="/images/purpleSonar.png"
        height="690"
        width="1280"
        contain
      ></v-img>
      <v-img
        src="/images/whiteLogo.svg"
        height="53"
        width="49"
        class="whiteLogo"
      ></v-img>
      <div class="text1 white--text sigflo-xl">
        <span
          >Build Your <span class="greenText">Dream<br />AVL System</span> with
          Sigflō</span
        >
      </div>
      <div class="text2 sigflo-m mutedWhiteText">
        Stop Struggling, Start Building
      </div>
      <div class="text3 sigflo-bodyLarge">
        Say goodbye to guesswork and hello to confidence. Experience the future
        of AVL technology with Sigflō. Start building your dream system today.
      </div>
      <v-btn
        outlined
        color="white"
        rounded
        dark
        width="300"
        height="76"
        class="button1"
        @click="localOpenSystem(data.projectTemplateId)"
        >Build Your System</v-btn
      >
    </v-row>
  </v-card>
</template>

<script>
  export default {
    props: {
      data: Object
    },
    methods: {
      localOpenSystem(systemId) {
        this.handleBuildSystemClick();
        this.openSystem(systemId, this.data);
      }
    }
  };
</script>

<style scoped>
  .main {
    padding-top: 80px;
    padding-bottom: 40px;
  }
  .purpleContainer {
    position: relative;
  }
  .text1 {
    position: absolute;
    top: 125px;
    left: 200px;

    display: flex;
    width: 860px;
    height: 178px;
    flex-direction: column;
    justify-content: center;
    flex-shrink: 0;
  }
  .text2 {
    position: absolute;
    top: 350px;
    left: 200px;

    width: 469px;
    height: 109px;
    flex-shrink: 0;

    opacity: 0.6;
  }
  .text3 {
    position: absolute;
    top: 360px;
    left: 650px;

    width: 563px;

    color: var(--White, var(--White, #fff));
    font-feature-settings: 'clig' off, 'liga' off;
  }
  .button1 {
    font-weight: 600;
    font-family: 'Inter V';
    font-size: 24px;
    position: absolute;
    bottom: 95px;
    left: 650px;
    border-radius: 38px;
  }
  .whiteLogo {
    position: absolute;
    top: 45px;
    right: 170px;
  }
</style>
